/**
 * Extract class name from CSS selector.
 * Handles selectors like "et-db #et-boc .et-l .et_pb_row_1_tb_body" -> "et_pb_row_1_tb_body",
 * and composite selectors like ".foo.bar" -> "bar".
 *
 * @param {string} selector CSS selector string.
 * @returns {string} Clean class name without leading dot.
 */
export const extractClassFromSelector = (selector: string): string => {
  const normalizedSelector = selector.trim();

  if (!normalizedSelector) {
    return '';
  }

  // Multi-selector entries can be comma-separated. Use the first selector branch.
  const primarySelector = normalizedSelector.split(',')[0]?.trim() ?? normalizedSelector;
  const classMatches = Array.from(primarySelector.matchAll(/\.([A-Za-z0-9_-]+)/g));

  if (0 === classMatches.length) {
    return '';
  }

  // Use the last class token to target the most specific element in selector chains.
  return classMatches[classMatches.length - 1]?.[1] ?? '';
};
